var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('grid',{attrs:{"descriptions":_vm.descriptions,"grouping":_vm.grouping},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}}),_c('van-button',{attrs:{"type":"primary","size":"large"},on:{"click":_vm.save}},[_vm._v("保存")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }